import { PopperTooltip } from "~/common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { type ReactNode, useState } from "react";
import { IconSize } from "~/common/mui/icons/IconSize";
import { GlobalStyles, Stack, styled } from "~/common/mui";
import CheckIcon from "@mui/icons-material/Check";
import FileCopyIcon from "@mui/icons-material/FileCopy";

interface CopyClipboardProps {
  className?: string;
  side?: "left" | "right" | "bottom" | "top";
  iconSize?: IconSize;
  text: string;
}

const iconSizeToFontSize = (iconSize?: IconSize): number => {
  switch (iconSize) {
    case IconSize.FONT_10:
      return 10;
    case IconSize.FONT_20:
      return 20;
    case IconSize.FONT_24:
      return 24;
    case IconSize.FONT_30:
      return 30;
    case IconSize.FONT_50:
      return 50;
    case IconSize.FONT_64:
      return 64;
    case IconSize.FONT_16:
    default:
      return 16;
  }
};

const CopyToClipboard = (props: CopyClipboardProps) => {
  const { className, side = "bottom", iconSize, text } = props;
  const { t } = useTranslation();

  const copyMessage = <span>{t("generic.copyToClipboard")}</span>;
  const [tooltip, setTooltip] = useState<ReactNode>(copyMessage);

  const resetTooltipContent = () => {
    setTooltip(copyMessage);
  };

  const copyClipboard = () => {
    navigator.clipboard.writeText(text);
    const copiedMessage = (
      <Stack direction="row" gap={0.5} alignItems="center">
        <CheckIcon  />
        {t("generic.copiedToClipboard")}
      </Stack>
    );
    setTooltip(copiedMessage);
  };

  return (
    <>
      <GlobalStyles styles={{ [`.${popupInnerClassName}`]: { display: "flex" } }} />
      <ClipboardTooltip
        className={className}
        innerClassName={popupInnerClassName}
        tooltipContent={tooltip}
        placement={side}
        onTooltipClosed={resetTooltipContent}
      >
        <FileCopyIcon
          className="f-green"
          sx={{ fontSize: iconSizeToFontSize(iconSize) }}
          onClick={copyClipboard}
        />
      </ClipboardTooltip>
    </>
  );
};

const popupInnerClassName = "scha__copy-to-clipboard__popup-inner";

const ClipboardTooltip = styled(PopperTooltip)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

export default CopyToClipboard;
